import { createContext, useContext, ReactNode } from 'react'

interface FormValidationContextType {
  triggerValidation: () => void
  registerValidationTrigger: (callback: () => void) => void
  unregisterValidationTrigger: () => void
}

const FormValidationContext = createContext<FormValidationContextType | undefined>(undefined)

export const FormValidationProvider = ({ children }: { children: ReactNode }) => {
  let validationCallback: (() => void) | null = null

  const registerValidationTrigger = (callback: () => void) => {
    validationCallback = callback
  }

  const unregisterValidationTrigger = () => {
    validationCallback = null
  }

  const triggerValidation = () => {
    if (validationCallback) {
      validationCallback()
    }
  }

  return (
    <FormValidationContext.Provider value={{ triggerValidation, registerValidationTrigger, unregisterValidationTrigger }}>
      {children}
    </FormValidationContext.Provider>
  )
}

export const useFormValidation = () => {
  const context = useContext(FormValidationContext)
  if (!context) {
    throw new Error('useFormValidation must be used within a FormValidationProvider')
  }
  return context
} 